import { render, staticRenderFns } from "./404.vue?vue&type=template&id=1a473c4d&scoped=true&lang=pug&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=1a473c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a473c4d",
  null
  
)

export default component.exports